import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  ORDERS_DELETE_URL,
  ORDERS_LIST_URL,
  PRODUCT_IMAGE_URL,
} from "../../utils/Constant";
import { convertIsoToCustomFormat } from "../../utils/Helper";

const OrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orderIdToDelete, setOrderIdToDelete] = useState(null);
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.token);

  async function fetchOrders() {
    try {

      if (!authToken) {
        navigate('/login');
        //throw new Error("Authentication token not found");
      }


      const response = await fetch(ORDERS_LIST_URL, {
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
        credentials: "include",
      });
      if (response.status === 401) {
        navigate("/login");
        return;
      }
      const json = await response.json();
      setLoading(false);
      setOrders(json);
    } catch (err) {
      //console.log("err", err);
    }
  }

  //console.log("setOrders::::::::", orders);

  const handleDelete = (orderId) => {
    setOrderIdToDelete(orderId);
    setIsModalOpen(true);
  };

  const handleDetails = (orderID) => {
    navigate(`/orders/view/${orderID}`);
  };

  const handleCloseModal = () => {
    setOrderIdToDelete(null);
    setIsModalOpen(false);
  };

  const Modal = ({ isOpen, onClose, onDelete }) => {
    return (
      <div
        className={`modal ${isOpen ? "open" : ""}`}
        style={{
          left: "100px",
          top: "200px",
          transform: "translate(322px, 1px)",
          width: "50%",
        }}
      >
        <div className="modal-content">
          <p>Are you sure you want to delete?</p>
          <button onClick={onClose}>Cancel</button>
          <button onClick={onDelete}>Delete</button>
        </div>
      </div>
    );
  };
  const handleConfirmDelete = async () => {
    // Your delete logic here

    //console.log("deleted", orderIdToDelete);
    try {
      // const authToken = await loginUser();
      //console.log("authToken", authToken);

      await axios
        .delete(`${ORDERS_DELETE_URL}/${orderIdToDelete}`, {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
        })
        .then((response) => {
          
          // Check the status code to determine if the deletion was successful
          if (response.status === 200) {
            // setShowPopup(false);
            setTimeout(() => {
              handleCloseModal();
              fetchOrders();
            }, 2000);
          } else {
            console.error("Deletion failed. Status code:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting product:", error);
        });
    } catch (error) {
      console.error("Error deleting product:", error);
      // Handle other errors if needed
    }
  };

  const getStatusColor = (status, type) => {
    switch (type) {
      case "payment":
        switch (status) {
          case "pending":
            return "badge-warning";
          case "completed":
            return "badge-success";
          case "failed":
            return "badge-danger";
          default:
            return "badge-secondary";
        }
      case "order":
        switch (status) {
          case "processing":
            return "badge-warning";
          case "shipped":
            return "badge-info";
          case "delivered":
            return "badge-success";
          default:
            return "badge-secondary";
        }
      default:
        return "badge-secondary";
    }
  };

  //console.log("authToken::::", authToken);

  useEffect(() => {
    if (authToken) {
      fetchOrders();
    } else {
      navigate("/login");
    }
  }, []);

  return (
    <DashboardLayout>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Orders</h3>
          <div className="card-tools">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="collapse"
              data-toggle="tooltip"
              title="Collapse"
            >
              <i className="fas fa-minus" />
            </button>
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              data-toggle="tooltip"
              title="Remove"
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <div className="card-body table-responsive p-0">
          <table className="table table-striped projects">
            <thead>
              <tr>
                <th style={{ width: "5%" }}>Order Id</th>
                <th style={{ width: "8%" }}>Product Image</th>
                <th style={{ width: "16%" }}>Product Name</th>
                <th style={{ width: "12%" }}>Customer Name</th>
                <th style={{ width: "10%" }}>Order Amount</th>
                <th style={{ width: "10%" }}>payment Status</th>
                <th style={{ width: "12%" }}>Order Time</th>
                <th style={{ width: "8%" }}>Payment Status</th>
                <th style={{ width: "10%" }}>Order Status</th>
                <th style={{ width: "8%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td className="text-center" colSpan="10">
                    <div className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {!loading &&
                orders?.map((order, index) => {
                  // const formattedDate = new Date(
                  //   order.orderTime
                  // ).toLocaleDateString("en-US", {
                  //   year: "numeric",
                  //   month: "short",
                  //   day: "numeric",
                  // });
                  return (
                    <tr key={order._id}>
                      <td>{order.orderId}</td>
                      <td>
                        {order?.productId?.featuredImage ? (
                          <img
                            alt="product"
                            className="table-avatar"
                            src={`${PRODUCT_IMAGE_URL}/${order?.productId?.featuredImage}`}
                          />
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        <a
                          href={`https://www.mototrad.com/products/${order?.productId?._id}`}
                          target="_blank"
                          style={{"textDecoration": "none"}}
                        >
                          {order?.productId?.productName}
                        </a>
                      </td>

                      <td>{order?.customerId?.username}</td>
                      <td>${order.totalAmount}</td>
                      <td>
                        {order.pendingAmount == 0 ? (
                          `Paid ($${order?.paidAmount})`
                        ) : (
                          <>
                            <span> {`Paid ($${order?.paidAmount})`}</span>
                            <br />
                            <span> {`Pending ($${order?.pendingAmount})`}</span>
                            <br />
                          </>
                        )}
                      </td>
                      <td>{convertIsoToCustomFormat(order?.orderTime)}</td>
                      <td>
                        <span
                          className={`badge ${getStatusColor(
                            order.paymentStatus,
                            "payment"
                          )}`}
                        >
                          {order.paymentStatus}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${getStatusColor(
                            order.orderStatus,
                            "order"
                          )}`}
                        >
                          {order.orderStatus}
                        </span>
                      </td>
                      <td>
                        <i
                          class="fa fa-eye icon-gap"
                          onClick={() => handleDetails(order._id)}
                        ></i>{" "}
                        <i
                          class="fa fa-trash"
                          onClick={() => handleDelete(order._id)}
                        ></i>
                        <Modal
                          isOpen={isModalOpen}
                          onClose={handleCloseModal}
                          onDelete={handleConfirmDelete}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        {/* /.card-body */}
      </div>
    </DashboardLayout>
  );
};

export default OrderPage;
